<template>
  <sessions-list-wrapper
    v-bind:key="loading"
    v-bind:sessions_list="sessionsAnimated"
    title="Sessions terminées"
    no_result="Vous n'avez aucune session terminée."
    is_sessions_terminees
    current_space="formateur"
    v-bind:loading="loading" />
</template>
<script>
  import sessionsListWrapper from '@/views/_espace/_refonte/formateur/utils/sessions-list-wrapper.vue';
  import { API } from '@/http-common';
  import dates_helpers from '@/mixin/dates_helpers';
  import navigation_helpers from '@/mixin/navigation_helpers';

  export default {
    components: { sessionsListWrapper },
    mixins: [navigation_helpers, dates_helpers],
    data: () => ({
      loading: false,
      sessionsAnimated: []
    }),
    created() {
      this.fetchSessions();
    },
    methods: {
      async fetchSessions() {
        this.loading = true;
        const response = await API.get(
          'formateur/sessions-animees',
          this.$header_skip_redirection
        );

        this.sessionsAnimated = response.data.map((s) => ({
          ...s,
          duree: s.dureeMinutes && this.formatMinutesToHours(s.dureeMinutes),
          dureeAnim:
            s.dureeAnimation && this.formatMinutesToHours(s.dureeAnimation)
        }));
        this.loading = false;
      },
      goToFiche(event, params) {
        this.openFiche(event, params);
      },
      goToDetails(event, params) {
        const { reference } = params.data;

        if (reference) {
          this.$router.push(`/formateur/details?reference=${reference}`);
        }
      }
    }
  };
</script>
<style lang="scss" scoped></style>
